import { Button, Modal } from 'antd';
import Title from 'antd/es/typography/Title';
import styled from 'styled-components';

interface IProps {
  isVisible: boolean;
  isConfirming?: boolean;
  children: React.ReactNode | React.ReactNode[];
  title: React.ReactNode;
  onCancel(): void;
  onConfirm(): void;
  shouldDisableConfirm?: boolean;
  shouldDisableCancel?: boolean;
}

const ConfirmModal: React.FC<IProps> = ({
  isVisible,
  isConfirming,
  children,
  title,
  shouldDisableCancel,
  shouldDisableConfirm,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      open={isVisible}
      onCancel={onCancel}
      footer={false}
      destroyOnHidden={true}
    >
      <div>
        <Title level={5}>{title}</Title>
        {children}
        <ActionButtons>
          <Button onClick={onCancel} disabled={shouldDisableCancel}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={onConfirm}
            loading={isConfirming}
            disabled={shouldDisableConfirm}
          >
            Confirm
          </Button>
        </ActionButtons>
      </div>
    </Modal>
  );
};

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.spacing.xl};

  button {
    min-width: 100px;
    height: ${({ theme }) => theme.spacing.xl};
    margin-left: ${({ theme }) => theme.spacing.sm};
    > span {
      font-size: 14px;
    }
  }
`;

export default ConfirmModal;
